import {
  Box,
  OnlineSearch,
  SelectedUsers,
  TextBody,
  Upload,
  theme,
} from '@zappyrent/hundop';
import React from 'react';
import Media from 'react-media';

import {
  StyledButtonContainer,
  StyledCtaButton,
  StyledH3,
  StyledIconList,
  StyledLargeSubtitle,
} from '../TextPageLandlord/TextPageLandlord.styles';

const PubblicaAnnuncioGratis = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Pubblica il tuo annuncio gratis
      </StyledH3>
      <TextBody>
        Abbiamo studiato e predisposto un sistema intuitivo, sempre tracciabile
        in ogni suo dettaglio formale e sostanziale, proprio per permettere la
        conclusione di affitti sicuri tra privati, che realizzino guadagni
        adeguati e corrispondenti al valore dell’immobile. Nessuna trattativa da
        seguire, né appuntamenti da fissare: una volta che avrai caricato il tuo
        annuncio, saremo noi a lavorare per te.
      </TextBody>
      <StyledLargeSubtitle tag="strong">
        Rendi pubblico il tuo annuncio con pochi semplici passaggi
      </StyledLargeSubtitle>
      <StyledIconList
        content={[
          {
            icon: <Upload />,
            body: (
              <>
                <TextBody tag="strong">Carica il tuo annuncio</TextBody>
                <TextBody>
                  Hai tu il pieno controllo dei contenuti che vuoi pubblicare:
                  aggiungi i dettagli che definiscono le caratteristiche
                  dell’appartamento o della stanza che intendi affittare,
                  descrivi la località in cui si trova l’alloggio, allega le
                  foto descrittive degli ambienti e rendi disponibile il tuo
                  alloggio a visite fisiche. Più completo sarà il tuo annuncio,
                  maggiore sarà la probabilità di ricevere prenotazioni di
                  affitto e anche i tempi di ricezione e di contrattazione si
                  accorceranno. Pubblica il tuo annuncio gratuito sulla
                  piattaforma, senza commissioni e senza costi aggiuntivi.
                </TextBody>
              </>
            ),
          },
          {
            icon: <OnlineSearch />,
            body: (
              <>
                <TextBody tag="strong">Gli inquilini prenotano online</TextBody>
                <TextBody>
                  Non avrai più bisogno di organizzare appuntamenti per definire
                  i termini della contrattazione, perché gli inquilini fanno le
                  loro richieste direttamente sul sito, riferendosi all’annuncio
                  così come da te pubblicato. Possono accettare il prezzo che
                  hai proposto o fare un’offerta diversa, che sarà tua
                  discrezione accettare o meno, con l’ulteriore possibilità di
                  fare una controproposta per arrivare ad un accordo
                  completamente condiviso.
                </TextBody>
              </>
            ),
          },
          {
            icon: <SelectedUsers />,
            body: (
              <>
                <TextBody tag="strong">Scegli il tuo nuovo inquilino</TextBody>
                <TextBody>
                  Hai già esaurito il tuo compito pubblicando l’annuncio, nel
                  quale descrivi l’immobile e proponi le tue condizioni
                  contrattuali. Adesso che il tuo annuncio è online, non dovrai
                  far altro che attendere di ricevere le richieste di
                  prenotazione e procedere a valutarle. Sarai tu a scegliere il
                  nuovo inquilino del tuo appartamento, sulla base delle
                  informazioni che noi di Zappyrent ti forniremo.
                </TextBody>
              </>
            ),
          },
        ]}
      />
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
        defaultMatches={{ desktop: true }}
      >
        {matches => (
          <>
            {matches.desktop && (
              <StyledButtonContainer>
                <Box lg={2}>
                  <StyledCtaButton
                    href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                    tag="a"
                    title="Pubblica un Annuncio"
                  >
                    Pubblica un annuncio
                  </StyledCtaButton>
                </Box>
              </StyledButtonContainer>
            )}
          </>
        )}
      </Media>
      <TextBody>
        Sarai libero di siglare l’accordo solo con affittuari disposti a pagare
        puntualmente, per avere la certezza di ottenere un guadagno dall’affitto
        del tuo immobile.{' '}
        <strong>
          Non dovrai mai preoccuparti di riscuotere i canoni mensili, perché lo
          faremo noi al posto tuo.
        </strong>{' '}
        Il metodo di riscossione e pagamento scelto da noi, prevede che sia
        compito di Zappyrent prendersi cura di svolgere tutti i passaggi,
        addebitando i pagamenti mensili sul conto dell’inquilino e procedendo
        all’accredito diretto sul tuo account. E quando il periodo di locazione
        sarà giunto al termine, restituiremo all’inquilino il deposito
        cauzionale congelato sul suo account, senza costi aggiuntivi, a meno che
        tu non dovessi lamentare un danno provato e documentato: in tal caso la
        cauzione verrebbe utilizzata per risarcire il danno da te subìto.
      </TextBody>
    </>
  );
};

export default PubblicaAnnuncioGratis;
